import { getLocalizedText } from '../hooks/useLocalizedText';

function getRequestLocale() {
  return localStorage.getItem('methaq_locale') || 'ar';
}

/**
 * @param {string | { en?: string, ar?: string } | null | undefined} message
 * @param {string} [locale]
 */
export function normalizeErrorMessage(message, locale = getRequestLocale()) {
  if (!message) return '';
  if (typeof message === 'string') return message;
  return getLocalizedText(message, locale);
}

/**
 * @param {import('axios').AxiosError | { response?: { data?: unknown } }} error
 */
export function parseApiError(error) {
  const data = error.response?.data;
  if (data?.errors?.length) {
    const first = data.errors[0];
    return {
      code: first.code,
      message: normalizeErrorMessage(first.message || data.message),
      errors: data.errors,
      requestId: data.requestId,
      status: error.response?.status,
    };
  }
  if (data?.message) {
    return {
      code: data.code || 'API_ERROR',
      message: normalizeErrorMessage(data.message),
      status: error.response?.status,
    };
  }
  return {
    code: 'NETWORK_ERROR',
    message: error.message || 'An unexpected error occurred',
    status: error.response?.status,
  };
}

/**
 * @param {Error & { apiError?: ReturnType<typeof parseApiError> }} error
 * @param {string} [locale]
 */
export function getApiErrorMessage(error, locale = getRequestLocale()) {
  if (error?.apiError?.message) {
    return normalizeErrorMessage(error.apiError.message, locale);
  }
  if (error?.apiError?.code) {
    return error.apiError.code;
  }
  return normalizeErrorMessage(error?.message, locale) || 'Something went wrong';
}

/**
 * @param {import('../types/common').ApiError[] | undefined} errors
 */
export function getErrorMessage(errors, fallback = 'Something went wrong') {
  if (!errors?.length) return fallback;
  const err = errors[0];
  const message = normalizeErrorMessage(err.message);
  if (message) return message;
  return err.code || fallback;
}
